import { useState } from 'react';
import {
  collection,
  getDoc,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  addDoc,
} from 'firebase/firestore';
import { db } from '@/app/firebase/config';

function useAddOrUpdateCustomer() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addOrUpdateCustomer = async (
    basketID,
    billingID,
    deliveryID,
    customerData,
    customerID
  ) => {
    setLoading(true);
    setError(null);
    try {
      const customersRef = collection(db, 'customers');
      console.log('customerID : '), customerID;
      if (!customerID) {
        // If customerID is not provided, check by email
        const emailQuery = query(
          customersRef,
          where('email', '==', customerData.email)
        );
        const querySnapshot = await getDocs(emailQuery);

        if (!querySnapshot.empty) {
          // Customer found by email
          const existingCustomerDoc = querySnapshot.docs[0];
          customerID = existingCustomerDoc.id;
        }
      }

      if (customerID) {
        // Update existing customer
        const customerDocRef = doc(db, 'customers', customerID);
        const existingCustomerData = (await getDoc(customerDocRef)).data();

        // Check if basketID already exists in the baskets array
        const existingBaskets = existingCustomerData.baskets || [];
        const updatedBaskets = existingBaskets.includes(basketID)
          ? existingBaskets // If basketID already exists, don't add it
          : [...existingBaskets, basketID]; // Add basketID if it's unique

        await updateDoc(customerDocRef, {
          ...existingCustomerData,
          ...customerData, // Overwrite with updated data
          deliveryID,
          billingID,
          baskets: updatedBaskets,
          updatedAt: new Date(),
        });

        console.log('Customer updated with ID:', customerID);
      } else {
        // Create a new customer record
        const newCustomerRef = await addDoc(customersRef, {
          ...customerData,
          deliveryID,
          billingID,
          baskets: [basketID],
          createdAt: new Date(),
        });
        customerID = newCustomerRef.id;
        console.log('New customer created with ID:', customerID);
      }

      setLoading(false);
      console.log('Returning customerID from addOrUpdateCustomer:', customerID);
      return customerID; // Return the customer ID
    } catch (err) {
      console.error('Error adding or updating customer:', err);
      setError(err.message);
      setLoading(false);
      throw err; // Re-throw for the caller
    }
  };

  return { addOrUpdateCustomer, loading, error };
}

export default useAddOrUpdateCustomer;
